

exports.__esModule = true;

var _angular = require('angular');

var _ul = require('components/xo-login-components/src/unified-login/ul');

var _squid = require('squid');

var _index = require('squid/index');

var _index2 = require('xo-models/src/checkout/index');

var _index3 = require('xo-models/src/user/index');

var _index4 = require('xo-models/src/shoppingcart/index');

var _index5 = require('xo-models/src/shippingMethod/index');

var _index6 = require('xo-models/src/inventory/index');

var _index7 = require('xo-models/src/onboard/index');

var _index8 = require('xo-models/src/fi/index');

var _fiApis = require('xo-models/src/fi//lib/fiApis');

var _index9 = require('xo-models/src/auth/index');

var _logger = require('xo-beaver/dist/logger');

var _uiRouter = require('uiRouter');

var _index10 = require('xo-device-info/dist/index');

var _index11 = require('xo-models/src/marketingoffer/index');

var _directive = require('components/xo-form-components/src/national-id-input/directive');

var _util = require('xo-wallet-components/src/fi-contingency-list/util');

var _sticky = require('./sticky');

var _util2 = require('../lib/util');

var _errorHandlerHelper = require('./lib/errorHandlerHelper');

var errorHandlerHelper = _interopRequireWildcard(_errorHandlerHelper);

var _pxpExperimentConstants = require('./constants/pxpExperimentConstants');

var _pxpExperimentConstants2 = _interopRequireDefault(_pxpExperimentConstants);

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./countryList/directive.js');

require('./emailInput/directive.js');

require('./passwordInput/directive.js');

require('./onboardOptions/directive.js');

require('./currencyConversion/directive.js');

require('./select-shipping-method/directive.js');

require('components/xo-form-components/src/select-shipping-country/directive.js');

require('components/xo-address-components/src/add-address/directive.js');

require('./sepa/directive.js');

require('components/xo-form-components/src/phone/phoneInput/directive.js');

require('components/xo-form-components/src/name-input/directive.js');

require('components/xo-wallet-components/src/add-bank/bank-input/directive.js');

require('components/xo-address-components/src/address-normalization/directive.js');

require('components/xo-wallet-components/src/3ds/directive.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

exports['default'] = _index.$Component.extend('xoOnboardPayment', {
    tag: 'xo-onboard-payment',
    template: _template2['default'],

    props: {
        token: {
            type: 'var'
        },
        mode: {
            type: 'var'
        },
        isUnbranded: {
            type: 'var'
        },
        paymentMethod: {
            type: 'var'
        },
        singleStepModel: {
            type: 'var'
        },
        buttonParams: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            return {
                auth: _index9.$AuthModel.instance(this.token).retrieve(),
                payee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve(),
                checkoutInputData: _index3.$CheckoutInputDataModel.instance(this.token).retrieve()
            };
        },
        shippingRule: function shippingRule(resolvers) {
            var _this = this;

            return resolvers.models.then(function (models) {
                if (models.checkoutAppData.doec_on_approve()) {
                    return {
                        profileRulesSummary: _index5.$ShippingRuleSummaryModel.instance(_this.token).retrieve({
                            params: {
                                merchant_id: models.payee.merchant.id,
                                currency_code: models.checkoutCart.purchase.amounts.total.currency_code
                            }
                        })
                    };
                }
            });
        },
        experiments: function experiments() {
            return {
                signupOnetouch: (0, _squid.$pxp)('xo_xoonboardingnode_signup_onetouch', { 'ctx.COUNTRY': _index.$locale.country }, '(signup_onetouch_)(.*)')

            };
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            this.locale = _index.$locale;
            this.currentState = _uiRouter.$state.current.name;
            this.upsellOptInDisplayed = false;
            this.flags = {
                shipToBilling: true,
                allowEditShipping: true,
                showSingleAddress: false,
                showShippingLabel: true,
                cupDetected: false,
                hideShippingAddress: false,
                allowPayWithSnT: false,
                allowSnTCall: true,
                instantUpdateShippingRegionSupported: true
            };

            this.sepa = {
                sepaGuestAgree: false,
                sepaAgree: false,
                show: false
            };

            var app_int_type = _index10.$DeviceInfo.isWebView() ? 'WebView' : _index10.$DeviceInfo.getAppIntegrationType();

            // fpti log for app integration type
            _logger.$logger.info('checkout_fpti', {
                'app_int_type': app_int_type
            });

            _logger.$logger.info('checkout_fpti', {
                page: 'main:ec:hermes::fullpage-billing:guest:hermes:'
            });

            // set the china upop flag on event heard
            this.$watch('onboard.card.type', function (newVal) {
                _this2.flags.cupDetected = newVal === 'CUP';
            });

            $(document).on('click', '#pomaLegalterms a', function () {
                _angular.$rootScope.$broadcast('trackInput', {
                    currentRoute: _uiRouter.$state.current,
                    page: 'main:ec:hermes::fullpage-billing:guest:aries:',
                    transition: $(_this2).text().replace(/\s/g, '_')
                });
            });

            // This is needed in Sepa directive
            this.sectionElement = '#singlePagePayment';

            this.countries = function () {
                return _index.$locale.content.countryList;
            };

            var triggerPageDesignFPTILog = function triggerPageDesignFPTILog() {
                var pageContext = 'Full-context';
                if (_angular.$rootScope.miniBrowser) {
                    pageContext = 'In-context';
                }

                _logger.$logger.info('checkout_fpti', {
                    'design': pageContext
                });
            };
            // Log Initial Page Design
            triggerPageDesignFPTILog();
            // Trigger Design FPTI Log on Page Design Change
            _angular.$rootScope.$watch('miniBrowser', triggerPageDesignFPTILog);

            var getPresetPaymentMethod = function getPresetPaymentMethod() {

                var paymentMethod = _this2.paymentMethod && _this2.paymentMethod.toLowerCase();

                if (!paymentMethod || paymentMethod !== 'bank' && paymentMethod !== 'card') {
                    return;
                }

                return paymentMethod === 'bank' ? 'bank' : 'card';
            };

            this.showFISwitchTab = function () {
                if (getPresetPaymentMethod()) {
                    return false;
                }
                return (0, _index.$feature)('fiSwitchTab', false, _index.$locale.country);
            };

            this.getDefaultFIMode = function () {
                var presetPayMentMethod = getPresetPaymentMethod();

                if (presetPayMentMethod) {
                    return presetPayMentMethod;
                }

                if (_index.$locale.country === 'DE') {
                    return 'bank';
                }
                return 'card';
            };

            this.onboard = new _index7.$OnboardModel({

                user: _index7.$OnboardUserModel.instance(this.token, {
                    country: _index.$locale.country,
                    countryOfResidence: _index.$locale.country,
                    nationality: _index.$locale.country
                }),

                card: new _index8.$CardModel(),

                bank: new _index8.$BankModel(),

                fiMode: this.getDefaultFIMode(),

                billing_address: _index8.$BillingAddressModel.create(this.token, {
                    country: _index.$locale.country
                }),
                shipping_address: _index2.$ShippingAddressModel.create(this.token, {
                    country: _index.$locale.country
                }),

                phone: new _index7.$OnboardPhoneModel(),

                // If the country does NOT have a UI option for marketingOptin for user, then default this flag to true.
                // If the country has marketing offer UI option then this value is controlled by what user selects
                marketingOptin: !(0, _index.$feature)('marketingOptinMember'),

                shipping_address_validation: false,
                poma_flow: false
            });

            this.onboard.card.ppconversion = 'PAYPAL';
        },
        populate: function populate() {
            var _this3 = this;

            if (this.shippingRule && this.shippingRule.profileRulesSummary) {
                this.flags.wps_SnT_flow = this.shippingRule.profileRulesSummary.isSnTEnabled;
            }

            // pre-fill user first name and last name.
            // override happens at handlePrefillShippingAndBillingAddress if merchant passing
            // shipping address during cart creation.
            this.onboard.user.first_name = this.models.checkoutCart.payer && this.models.checkoutCart.payer.first_name;
            this.onboard.user.last_name = this.models.checkoutCart.payer && this.models.checkoutCart.payer.last_name;

            var setAllowShipToBilling = function setAllowShipToBilling(allow) {
                // Toggle checkbox
                _this3.flags.disallowShipToBilling = !allow;
                // Show/Hide shipping address section
                _this3.flags.shipToBilling = allow;
            };

            var checkProcessorDecline = function checkProcessorDecline() {
                var processorDeclined = _this3.models.checkoutAppData.get('flags.processor_declined');
                if (processorDeclined) {
                    _this3.errorMessage = {
                        msgs: [(0, _squid.$renderContent)('payment.processorDeclineMemberNoFIGeneric')],
                        type: 'warning'
                    };
                }
            };

            var setChangeShippingCountryAlertMsg = function setChangeShippingCountryAlertMsg() {
                var countryName = (0, _squid.$renderContent)('shippingCountry.' + _this3.merchantCountry);
                var infoMessage = (0, _squid.$renderContent)('largeScreenPayment.blockNonDomesticShippingAlert', { shippingCountry: countryName });
                _this3.changeShippingCountryAlert = {
                    msgs: [infoMessage],
                    type: 'info'
                };
            };

            // pre-populate shipping and billing address
            var updateShippingAndBillingAddress = function updateShippingAndBillingAddress(shippingAddress, billingAddress) {
                // Detect invalid length country codes in which case we invalidate the country code.
                // A default value of $locale.country will subsequently be picked up for invalidated country codes in the model creation.
                if (shippingAddress && shippingAddress.country_code && shippingAddress.country_code.length !== 2) {
                    shippingAddress.country_code = undefined;
                }

                if (billingAddress && billingAddress.country_code && billingAddress.country_code.length !== 2) {
                    billingAddress.country_code = undefined;
                }
                // pre-fill billing address with shipping address
                _this3.onboard.shipping_address = _index2.$ShippingAddressModel.create(_this3.token, {
                    country: shippingAddress.country_code || _index.$locale.country
                }, shippingAddress);

                // pre-fill provided billing address
                _this3.onboard.billing_address = _index8.$BillingAddressModel.create(_this3.token, {
                    country: billingAddress.country_code || _index.$locale.country
                }, billingAddress);
            };

            var showGenericError = function showGenericError(code) {
                return function () {
                    _uiRouter.$state.go('checkout.genericError', { code: code });
                };
            };
            // handle billing and shipping address prefill scenarios
            var handlePrefillShippingAndBillingAddress = function handlePrefillShippingAndBillingAddress(allowPrefillShippingAddress, prefilledAddress, prefilledBillingAddress) {
                // if both shipping and billing addresses are provided
                if (allowPrefillShippingAddress && prefilledAddress && prefilledBillingAddress) {
                    updateShippingAndBillingAddress(prefilledAddress, prefilledBillingAddress);

                    // uncheck ship to billing checkbox
                    _this3.flags.shipToBilling = false;
                } else if (allowPrefillShippingAddress && prefilledAddress) {
                    // if only shipping address is provided

                    // pre-fill user first name and last name
                    _this3.onboard.user.first_name = prefilledAddress.first_name;
                    _this3.onboard.user.last_name = prefilledAddress.last_name;

                    updateShippingAndBillingAddress(prefilledAddress, prefilledAddress);
                    if (!_this3.flags.allowEditShipping) {
                        _this3.flags.shipToBilling = false;
                    }
                } else if (prefilledBillingAddress) {
                    // if only billing address is provided
                    updateShippingAndBillingAddress(prefilledBillingAddress, prefilledBillingAddress);
                }
            };

            // remove this upon oas ramp completion
            this.onboard.testParams = {
                oas: _index.$util.param('oas'),
                cardCandidate: _index.$util.param('cardCandidate')
            };

            this.$on('localeChange', function () {
                _this3.onboard.fiMode = _this3.getDefaultFIMode();
                _this3.onboard.billing_address.country = _index.$locale.country;
                _this3.onboard.user.country = _index.$locale.country;
                _this3.onboard.user.nationality = _index.$locale.country;
                _this3.onboard.marketingOptin = !(0, _index.$feature)('marketingOptinMember');
                _this3.setBackButtonForWebview();

                if (_this3.flags.disableChangeShippingCountry) {
                    if (_this3.flags.allowEditShipping) {
                        setAllowShipToBilling(_index.$locale.country === _this3.merchantCountry);
                    }
                } else {
                    _this3.onboard.shipping_address.country = _index.$locale.country;
                }
            });

            this.$on('contentChange', function () {
                if (_this3.flags.disableChangeShippingCountry) {
                    setChangeShippingCountryAlertMsg();
                }
            });

            this.$on('signupClickedTimerStarted', function (event, time) {
                _this3.signupClickedStartTime = time;
            });

            this.redirect = function () {
                _logger.$logger.info('basl_throttle_test_login');
                (0, _squid.$dispatch)('hermes', {
                    hermesLoginRedirect: 'xoon',
                    token: _this3.token,
                    'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
                    'country.x': _index.$locale.country
                });
            };

            this.$watch('flags.shipToBilling', function (shipToBilling) {
                if (!shipToBilling && _this3.flags.allowEditShipping) {
                    $.each(_this3.onboard.billing_address, function (key, val) {
                        if (angular.isString(_this3.onboard.billing_address[key]) && !_this3.onboard.shipping_address[key]) {
                            _this3.onboard.shipping_address[key] = val;
                        }
                    });

                    _this3.onboard.shipping_address.first_name = _this3.onboard.shipping_address.first_name || _this3.onboard.user.first_name;
                    _this3.onboard.shipping_address.last_name = _this3.onboard.shipping_address.last_name || _this3.onboard.user.last_name;
                }
            });

            // Format address to display when store pick is selected
            var formatAddress = function formatAddress(address) {

                var COMMA = ', ';
                var SPACE = ' ';

                function prefix(str, prefixStr) {
                    if (str) {
                        return (prefixStr ? prefixStr : '') + str;
                    }
                    return '';
                }

                var displayLine1 = (address.line1 ? address.line1 : '') + (address.line2 ? prefix(address.line2, COMMA) : '');
                var displayLine2 = (address.city ? prefix(address.city) : '') + (address.state ? prefix(address.state, COMMA) : '') + (address.postal_code ? prefix(address.postal_code, SPACE) : '');
                var displayLine3 = address.country ? prefix(address.country) : '';

                return {
                    displayLine1: displayLine1,
                    displayLine2: displayLine2,
                    displayLine3: displayLine3
                };
            };

            var storePickUpSelected = _angular.$rootScope.$on('store_pick_up_selected', function (event) {
                if (_this3.flags.shipToBilling) {
                    _this3.shippingAddress = formatAddress(_this3.onboard.billing_address);
                } else {
                    _this3.shippingAddress = formatAddress(_this3.onboard.shipping_address);
                }
            });

            this.$on('$destroy', storePickUpSelected);

            var showErrorFields = _angular.$rootScope.$on('showErrorFields', function (event) {
                _this3.toggleAddressFieldsValidation(true);
            });

            this.$on('$destroy', showErrorFields);

            var hideErrorFields = _angular.$rootScope.$on('hideErrorFields', function (event) {
                _this3.toggleAddressFieldsValidation(false);
            });

            this.$on('$destroy', hideErrorFields);

            // useraction flag
            var useraction = this.models.checkoutAppData.useraction();
            this.flags.commit = useraction && useraction.toLowerCase() === 'commit';
            _logger.$logger.info('checkout_fpti', {
                'billing_page_button_text': this.flags.commit ? 'paynow_y' : 'paynow_n'
            });

            this.wpsFlow = this.models.checkoutAppData.doec_on_approve();

            // show shipping address based on merchant passed in parameter
            this.showShippingAddress = Boolean(!this.models.checkoutAppData.flags.hide_shipping_address && this.models.checkoutAppData.flags.shipping_address_required);

            this.isInstantUpdateFlow = this.models.checkoutCart.instantUpdateIntegration;
            if (this.isInstantUpdateFlow) {
                this.trackSntReq = {};
            }

            // flags.allowEditShipping = false, skip saving shipping address validation otherwise don't skip.
            this.flags.allowEditShipping = this.models.checkoutAppData.get('flags.allow_change_shipping', false);

            // saving in to user object so that email field pre-populate if its passed in from setEc.
            this.onboard.user.email = this.models.checkoutCart.payer && this.models.checkoutCart.payer.email;

            this.getPageTitle = function () {
                if (_this3.models.checkoutInputData.isEbayTxn()) {
                    // prox signup flow title
                    return _index.$locale.content.get('signupAccountCreation.heading');
                } else if (_this3.onboard.fiMode === 'bank') {
                    return _index.$locale.content.get('largeScreenPayment.bankTitle');
                } else if (_this3.models.checkoutCart.isWalletTokenization()) {
                    return _index.$locale.content.get('common.createPayPalSubTitleSignup');
                } else if (_this3.mode === 'signup') {
                    return _index.$locale.content.get('largeScreenPayment.signupTitle');
                } else {
                    return _index.$locale.content.get('largeScreenPayment.title');
                }
            };
            this.getPageTitleProps = function () {
                if (_this3.models.checkoutCart.isWalletTokenization()) {
                    return _index.$locale.content.get('signup.androidPayTitleProp');
                } else {
                    return _index.$locale.content.get('largeScreenPayment.titleProp');
                }
            };

            // *** NOTE:
            // PXP was initially intended to be used with login button, but we've opted to use back button
            // page name and treatments still have login in the name though.
            this.flags.backButtonWebview = false;
            this.setBackButtonForWebview = function () {
                if (_index10.$DeviceInfo.isWebView(false)) {
                    var floatThrottle = parseFloat((0, _index.$feature)('webviewBackButtonThrottle', 0, _index.$locale.country));
                    if (isNaN(floatThrottle)) {
                        return;
                    }

                    _this3.flags.backButtonWebview = floatThrottle && (0, _squid.$experiment)('webview_backbutton_throttle', floatThrottle, _angular.$rootScope.token, {}) ? true : false;
                    if (_this3.flags.backButtonWebview) {
                        _logger.$logger.info('BACK_BUTTON_SHOWN_FOR_WEBVIEW');
                    }
                }
            };

            this.setBackButtonForWebview();

            // Set the upop interstitional continue button content key value
            if (this.wpsFlow) {
                this.upopConfirmButtonTextKey = 'confirmUpop.confirmAndContinue';
            } else if (this.flags.commit) {
                this.upopConfirmButtonTextKey = 'confirmUpop.confirmAndPay';
            } else {
                this.upopConfirmButtonTextKey = 'confirmUpop.confirmAndContinueToMerch';
            }

            this.landingAbTestCheck = function () {
                /**
                 * Show the login button on xoon when:
                 * - hermes redirects to xoon in xo-landing-router
                 **/
                return _squid.$meta.query && _squid.$meta.query.abTestThrottle === 'xoon' ? true : false;
            };

            // Get merchant passed shipping address from either purchase plan or billing agreement plan
            var prefilledAddress = this.models.checkoutCart.get('purchase.shipping_address') || this.models.checkoutCart.get('billing.shipping_address');

            var prefilledNumber = this.models.checkoutCart.get('purchase.phone_fields') || this.models.checkoutCart.get('billing.phone_fields');

            if (prefilledNumber) {
                this.onboard.phone.telephone = prefilledNumber.normalized_phone_number;
            }

            var allowPrefillShippingAddress = !!prefilledAddress;

            var prefilledBillingAddress = this.models.checkoutCart.get('billing_address');

            this.merchantCountry = this.models.checkoutAppData.get('merchant.merchant_country', 'US');
            var merchant = this.models.checkoutAppData.merchant;
            this.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;

            if ((0, _index.$feature)('supportBlockNonDomesticShipping', false, this.merchantCountry)) {
                this.flags.disableChangeShippingCountry = this.models.checkoutAppData.get('flags.block_non_domestic_shipping', false);

                if (this.flags.disableChangeShippingCountry) {

                    _logger.$logger.info('onboard_block_non_domestic_shipping', {
                        block_non_domestic_shipping: this.flags.disableChangeShippingCountry,
                        allow_change_shipping: this.flags.allowEditShipping,
                        setec_shipping_country_code: prefilledAddress && prefilledAddress.country_code
                    });

                    if (!this.flags.allowEditShipping && prefilledAddress && prefilledAddress.country_code !== this.merchantCountry && prefilledAddress.country_code !== '') {
                        _uiRouter.$state.go('checkout.genericError', {
                            code: 'BLOCK_NON_DOMESTIC_SHIPPING'
                        });
                    }

                    if (prefilledAddress && prefilledAddress.country_code !== this.merchantCountry) {
                        allowPrefillShippingAddress = false;
                    }

                    setChangeShippingCountryAlertMsg();
                    this.onboard.shipping_address.country = this.merchantCountry;

                    // Show shipping address section if user locale is different from merchant country
                    if (this.flags.allowEditShipping && _index.$locale.country !== this.merchantCountry) {
                        setAllowShipToBilling(false);
                    }
                }
            }

            /**
             * Handle Card-Type based Installments e.g. Brazil is card_type based installments,
             * so fetch the installments during page load.
             */
            var handleCardTypeBasedInstallments = function handleCardTypeBasedInstallments() {

                _this3.$watch('singlePagePaymentForm.$valid', function (newVal, oldVal) {
                    var cardModel = _this3.onboard.card;

                    if (newVal.luhn && newVal.luhn[0].$name === 'cardNumber') {
                        cardModel.valid = false;
                    } else {
                        cardModel.valid = true;
                    }
                });

                _this3.$watch(_this3.onboard.card.type, function (newValue, oldValue) {
                    // Sanitize the values
                    newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;

                    var cardNetwork = void 0;
                    if (newValue && _this3.installments && _this3.installments.length > 0) {

                        _this3.installments.some(function cardCheck(card, index, array) {
                            if (card.cardInfo && card.cardInfo.card_type && card.cardInfo.card_type.toLowerCase() === newValue) {
                                // Card Network Found
                                cardNetwork = card;
                                return true;
                            }
                        });

                        if (cardNetwork && cardNetwork.installment_options && cardNetwork.installment_options.length > 0) {
                            // Card network && installments found
                            if (cardNetwork.installment_options.length === 1) {
                                _this3.singleStepModel.selectedInstallmentData = {
                                    installment_option_selected: cardNetwork.installment_options[0],
                                    preventChange: true
                                };
                            }

                            _this3.singleStepModel.allowInstallments = true;
                        } else {
                            // Card network does not exists Or No installment found
                            _this3.singleStepModel.allowInstallments = false;
                        }
                    } else {
                        _this3.singleStepModel.allowInstallments = false;
                    }
                });
                var installments = _index2.$InstallmentOptionsModel.instance(_this3.token);
                installments.save({
                    data: {
                        payee: _this3.models.payee,
                        checkoutCart: _this3.models.checkoutCart,
                        checkoutAppData: _this3.models.checkoutAppData
                    },
                    success: function success(result) {
                        _this3.installments = result.installments;
                    }
                });
            };

            /**
             * Handle Issuer based Installments e.g. Mexico is issuer_based (bank) installments, so fetch the
             * installments after user enters card number
             */
            var handleIssuerBasedInstallments = function handleIssuerBasedInstallments() {

                _this3.cardNumberChanged = function (unformattedCardNumber) {

                    if (unformattedCardNumber && unformattedCardNumber !== _this3.prevCardNumber) {

                        // Make sure the Installments server is hit only once for a cardNumber
                        _this3.prevCardNumber = unformattedCardNumber;
                        var installments = _index2.$InstallmentOptionsModel.instance(_this3.token);
                        installments.save({
                            silent: true,
                            data: {
                                payee: _this3.models.payee,
                                checkoutCart: _this3.models.checkoutCart,
                                checkoutAppData: _this3.models.checkoutAppData,
                                cc: unformattedCardNumber
                            },
                            success: function success(result) {

                                _this3.installments = result;

                                if (result.installment_options && result.installment_options.length > 0) {

                                    _this3.issuerBasedInstallmentsRetrieved = true;

                                    // reset the previously selected installment
                                    _this3.singleStepModel.selectedInstallmentData = undefined;
                                    if (result.installment_options.length === 1) {
                                        _this3.singleStepModel.selectedInstallmentData = {
                                            installment_option_selected: result.installment_options[0],
                                            preventChange: true
                                        };
                                    }

                                    _this3.singleStepModel.allowInstallments = true;
                                } else {
                                    _this3.singleStepModel.allowInstallments = false;
                                }
                            }
                        });
                    }
                };
            };

            // Lookup installments only when amount is greater than zero.
            // for ex: Billing Agreements can create with amount=zero.
            if ((0, _index.$feature)('installments', false, _index.$locale.country) && this.models.checkoutCart.get('purchase.amounts.total.amount', 0) > 0) {

                if ((0, _index.$feature)('issuerBasedInstallments', false, _index.$locale.country)) {
                    // e.g. Mexico is issuer_based (bank) installments, so fetch the installments after user enters card number
                    handleIssuerBasedInstallments();
                } else {
                    // e.g. Brazil is card_type based installments, so fetch the installments during page load.
                    handleCardTypeBasedInstallments();
                }
            }

            this.isInstallmentsVisible = function () {
                if (!_this3.singleStepModel) {
                    return false;
                }
                _this3.singleStepModel.onboard = _this3.onboard;

                var model = _this3.onboard;
                var hasConditionMet = _this3.singleStepModel.allowInstallments && model.card.number && (model.card.valid || _this3.issuerBasedInstallmentsRetrieved);
                var isBilling = _this3.models.checkoutCart.isBilling();

                return !isBilling && hasConditionMet;
            };

            checkProcessorDecline();

            handlePrefillShippingAndBillingAddress(allowPrefillShippingAddress, prefilledAddress, prefilledBillingAddress);

            var experienceInitiator = this.models.checkoutAppData.get('flags.payment_experience_initiator');
            this.onboard.payment_experience_initiator = experienceInitiator;

            this.isApac = function () {
                return _index.$config.apacCountries && _index.$config.apacCountries.indexOf(_this3.locale.country) > -1;
            };

            this.$on('MORSDisplayed', function (event, args) {
                _this3.MORSDisplayed = args;
            });

            this.$on('MORSNotDisplayed', function (event, args) {
                _this3.MORSDisplayed = {};
            });

            var handleCardContingencySignup = function handleCardContingencySignup() {
                if (_this3.models.checkoutInputData.isEbayTxn()) {
                    (0, _squid.$dispatch)('prox', {
                        action: 'login'
                    });
                } else {
                    // redirect to hermes and we will see add card page
                    (0, _squid.$dispatch)('hermes', {
                        redirectToHermes: true,
                        token: _this3.token,
                        'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
                        'country.x': _index.$locale.country
                    });
                }
            };

            var handleCardContingencyGuest = function handleCardContingencyGuest() {
                var msg = void 0;

                if (_this3.models.payee.isGambling()) {
                    msg = _index.$locale.content.get('creditcard.noEligibleFI');
                } else if (_this3.onboard.billing_address.country === 'DE') {
                    if (_this3.onboard.fiMode === 'bank') {
                        delete _this3.onboard.bank;
                        msg = _index.$locale.content.get('creditcard.cannotUseBank');
                        _this3.onboard.fiMode = 'card';
                    } else {
                        msg = _index.$locale.content.get('creditcard.cannotUseCard');
                    }
                } else {
                    msg = _index.$locale.content.get('creditcard.errorInstrumentRefused');
                }

                _this3.errorMessage = {
                    msgs: [msg],
                    type: 'error'
                };
                return _angular.$q.reject();
            };

            var handleCardContingency = function handleCardContingency(action) {
                return _this3.flags.mode === 'signup' ? handleCardContingencySignup() : handleCardContingencyGuest();
            };

            var show3DSLightbox = function show3DSLightbox(checkoutSession) {

                _this3.resolve_3ds_data = {
                    cc_id: checkoutSession.get('resolve_3ds.ccId'),
                    flow_id: 'HERMES',
                    merchant_id: _this3.models.payee.get('merchant.id'),
                    merchant_country_code: _this3.models.checkoutAppData.get('merchant.merchant_country'),
                    transaction_amount_currency: _this3.models.checkoutCart.get('purchase.amounts.total.currency_code'),
                    transaction_amount_value: _this3.models.checkoutCart.get('purchase.amounts.total.amount')

                };
                _this3.launch3DSResolver = true;
            };

            var isDCCEligible = function isDCCEligible(checkoutSession) {
                var isGuest = _this3.flags.mode !== 'signup';
                var hasCurrencyConversion = checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable');

                if (!(isGuest && hasCurrencyConversion)) {
                    return false;
                }

                return _this3.flags.dccCountryEligibility;
            };

            /*
             * This function will determine final route of the transaction:
             * 1. return to merchant for all none WPS traffic
             * 2. go to checkout done page for WPS with not eligible interstitial traffic
             * 3. got to WPS interstitial for eligible(passes upgrade eligibility) WPS traffic
             */
            var finalRoute = function finalRoute() {

                if (_this3.wpsFlow) {
                    _this3.singleStepModel.onboard = _this3.onboard;
                    _this3.singleStepModel.flags = _this3.flags;
                    // set signup/guest flag so done page
                    // renders the proper content
                    _angular.$rootScope.mode = _this3.flags && _this3.flags.mode;
                    if (_this3.flags.wpsInterstitialEligible) {
                        if (_this3.flags.buyerMode === 'signup') {
                            return _uiRouter.$state.go('checkout.done');
                        }
                        return _this3.onboard.action('upgradeValidate', {

                            data: _this3.onboard.serialize(),

                            success: function success() {
                                return _uiRouter.$state.go('checkout.guest.guestUpgradeInterstitial');
                            },
                            contingencies: {
                                CC_LINKED: function CC_LINKED() {
                                    _logger.$logger.info('wps_interstitial_ineligible_CC_LINKED');
                                    return _uiRouter.$state.go('checkout.done'); // guest done page
                                },
                                EXISTING_MEMBER: function EXISTING_MEMBER() {
                                    _logger.$logger.info('wps_interstitial_ineligible_EXISTING_MEMBER');
                                    return _uiRouter.$state.go('checkout.done'); // guest done page
                                },
                                CC_LINKED_TO_FULL_ACCOUNT: function CC_LINKED_TO_FULL_ACCOUNT() {
                                    _logger.$logger.info('wps_interstitial_ineligible_CC_LINKED_TO_FULL_ACCOUNT');
                                    return _uiRouter.$state.go('checkout.done');
                                },
                                VALIDATION_ERROR: function VALIDATION_ERROR() {
                                    _logger.$logger.info('wps_interstitial_ineligible_VALIDATION_ERROR');
                                    return _uiRouter.$state.go('checkout.done');
                                },
                                DEFAULT: function DEFAULT() {
                                    _logger.$logger.info('wps_interstitial_ineligible - Unhandled contingency');
                                    return _uiRouter.$state.go('checkout.done');
                                }
                            },
                            validation: function validation(res) {
                                _logger.$logger.info('wps_interstitial_ineligible_SERVICE_VALIDATION_ERROR');
                                return _uiRouter.$state.go('checkout.done');
                            },
                            error: function error(res) {
                                _logger.$logger.info('wps_interstitial_ineligible_SERVICE_ERROR');
                                return _uiRouter.$state.go('checkout.done');
                            }
                        });
                    } else {
                        if (_this3.flags.poma_flow) {
                            _logger.$logger.info('LOGGING_OUT_WPS_POMA_FLOW_FOR_CLEARING_COOKIES');
                            // Logging out the user only for POMA before going to END state.
                            // why are we logging out?
                            // ACCESS_TOKEN dropped during passive login is 8hr expiration, due to which
                            // user is not authenticated in subsequent transaction in hermes review page
                            // while adding FI or Shipping Address.
                            // so by logging out the user, removes all the cookies except RT from the
                            // browser in which hermes does RT to AT exchange in the absence of AT and gets
                            // the limited AccessToken.
                            return _this3.models.auth.action('logout').then(function () {
                                return _uiRouter.$state.go('checkout.done');
                            });
                        }
                        // wps done route
                        return _uiRouter.$state.go('checkout.done');
                    }
                } else {
                    if (_this3.flags.poma_flow) {
                        _logger.$logger.info('LOGGING_OUT_POMA_FLOW_FOR_CLEARING_COOKIES');
                        // Logging out the user only for POMA before going to END state.
                        // why are we logging out?
                        // ACCESS_TOKEN dropped during passive login is 8hr expiration, due to which
                        // user is not authenticated in subsequent transaction in hermes review page
                        // while adding FI or Shipping Address.
                        // so by logging out the user, removes all the cookies except RT from the
                        // browser in which hermes does RT to AT exchange in the absence of AT and gets
                        // the limited AccessToken.
                        return _this3.models.auth.action('logout').then(function () {
                            return _uiRouter.$state.go('checkout.end');
                        });
                    }
                    // end otherwise
                    return _uiRouter.$state.go('checkout.end');
                }
            };

            // TODO: need to test this
            var handleSignupFlow = function handleSignupFlow() {

                if (_this3.experiments.signupOnetouch) {
                    /* Returns the flow name */
                    var flowName = _pxpExperimentConstants2['default'].test['onetouch'][_this3.experiments.signupOnetouch.treatment_name];
                    if (['signUpVariantOne', 'signUpVariantTwo'].indexOf(flowName) > -1) {
                        return upsellOptInDisplayed().then(function () {
                            if (_this3.upsellOptInDisplayed) {
                                // If the optin upsell is already displayed, no need to display again.
                                // go to end state.
                                return _uiRouter.$state.go('checkout.end');
                            } else {
                                /* Route to one touch interstitial page*/
                                return _uiRouter.$state.go('checkout.signup.oneTouchUpsell', { oneTouchFlowName: flowName });
                            }
                        });
                    }
                }
                // goto end state
                return finalRoute();
            };

            var handleSignupOrEnd = function handleSignupOrEnd() {
                if (_this3.mode === 'signup') {
                    return handleSignupFlow();
                } else {
                    return finalRoute();
                }
            };

            var authorize = function authorize() {
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this3.token);

                return checkoutSession.action('authorize', {
                    success: function success() {
                        if (_this3.wpsFlow) {
                            return checkInventoryAndPay(checkoutSession);
                        } else if (_this3.models.checkoutInputData.isEbayTxn()) {
                            return finalRoute();
                        } else {
                            return handleSignupOrEnd();
                        }
                    }
                });
            };

            var postCheckoutSessionOperations = function postCheckoutSessionOperations(dccComplete) {
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this3.token);

                if (!dccComplete && isDCCEligible(checkoutSession) && _this3.onboard.card.type === 'VISA') {
                    _logger.$logger.info('render_currency_conversion_lightbox');
                    if (_this3.flags.wpsInterstitialEligible) {
                        _logger.$logger.info('wps_interstitial_render_dcc');
                    }
                    _this3.launchCurrencyConversionLightbox = true;
                    return;
                }

                if (checkoutSession.resolve_3ds) {
                    return show3DSLightbox(checkoutSession);
                }

                return _angular.$q.when((0, _sticky.setStickyInstrument)(checkoutSession))['catch'](function (err) {
                    _logger.$logger.info('setStickyFI Failed', err);
                })['finally'](authorize);
            };

            this.onCompleteDCC = function (result) {
                if (result === 'close') {
                    _this3.launchCurrencyConversionLightbox = false;
                    return;
                } else {
                    _this3.launchCurrencyConversionLightbox = false;
                    return postCheckoutSessionOperations(true);
                }
            };

            var upsellOptInDisplayed = function upsellOptInDisplayed() {
                return _index9.$AuthModel.instance().retrieve().then(function (auth) {
                    if (auth.upsellOptInDisplayed) {
                        _this3.upsellOptInDisplayed = true;
                    }
                });
            };

            var makePayment = function makePayment(checkoutSession) {
                var wpsParams = _index.$util.decodeAndParse(_squid.$meta.xclickParams);

                return checkoutSession.action('createPayment', {
                    data: {
                        payer_id: checkoutSession.payer && checkoutSession.payer.id,
                        intent: _this3.models.checkoutCart.payment_action,
                        wa_type: wpsParams && wpsParams.wa_type,
                        correlation_id: _squid.$meta.correlationId,
                        merchant_id: _this3.models.payee.get('merchant.id'),
                        custom: _this3.models.checkoutCart.get('purchase.custom'),
                        invoice: _this3.models.checkoutCart.get('purchase.invoice')
                    },

                    success: function success(result) {
                        _angular.$rootScope.paymentComplete = true;
                        _this3.onboard.payerId = checkoutSession.payer && checkoutSession.payer.id;
                        _this3.onboard.transaction = result.transactionDetails && result.transactionDetails.id;
                        if (_index.$config.enableShoppingCartWPS && _this3.models.checkoutAppData.flags.is_shopping_cart_flow) {
                            markCartCheckedout();
                        }
                        return finalRoute();
                    },
                    contingencies: {
                        TRANSACTION_REFUSED: handlePaymentContingencies('TRANSACTION_REFUSED'),
                        INSTRUMENT_DECLINED: function INSTRUMENT_DECLINED() {
                            inventoryOperation('failed');
                            var param = {
                                mode: _this3.flags.mode
                            };
                            _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard', param);
                        },
                        PAYEE_BLOCKED_TRANSACTION: handlePaymentContingencies('PAYMENT_DENIED'),
                        DUPLICATE_TRANSACTION: handlePaymentContingencies('PAYMENT_ALREADY_DONE'),
                        DEFAULT: handlePaymentContingencies('DEFAULT')
                    },
                    error: function error(err) {
                        _logger.$logger.info('createPayment Failed due to service error', err);
                        inventoryOperation('failed');
                        return _uiRouter.$state.go('checkout.genericError', { code: 'DEFAULT' });
                    }
                });
            };

            var inventoryOperation = function inventoryOperation(paymentStatus) {
                var cartHasInventory = _this3.models.checkoutCart.get('cartHasInventory');
                if (cartHasInventory) {
                    var inventoryModel = _index6.$InventoryModel.instance(_angular.$rootScope.token);
                    var inventoryItems = inventoryModel.getInventoryItems();
                    var purchaseItems = _this3.models.checkoutCart.get('purchaseUnits');
                    var cartItems = void 0,
                        inventoryPatchInput = {};
                    if (purchaseItems && purchaseItems[0] && purchaseItems[0].item_list) {
                        cartItems = purchaseItems[0].item_list.items;
                    }
                    paymentStatus = paymentStatus ? paymentStatus : 'success';
                    if (cartItems && inventoryItems) {
                        inventoryPatchInput = {
                            inventoryItems: inventoryItems,
                            cartItems: cartItems,
                            merchantId: _this3.models.payee.get('merchant.id', ''),
                            paymentStatus: paymentStatus
                        };
                    } else {
                        return _angular.$q.when(); // don't need to call patchInventory if items not present
                    }

                    return inventoryModel.action('patchInventory', {
                        data: inventoryPatchInput,
                        success: function success(patchResponse) {
                            if (patchResponse) {
                                if (patchResponse.showSoldoutPage) {
                                    // show soldout page
                                    return {
                                        soldoutpage: true,
                                        items: patchResponse.soldoutItems,
                                        soldOutUrl: patchResponse.soldoutUrl
                                    };
                                } else if (patchResponse.patchCart) {
                                    var purchase_unit = _this3.models.checkoutCart.get('purchaseUnits')[0];
                                    purchase_unit.item_list.items = patchResponse.cartItems;
                                    var patchCartPayload = {
                                        id: _this3.token,
                                        patchEntities: [{
                                            field: 'inventoryItems',
                                            value: purchase_unit.item_list.items
                                        }]
                                    };

                                    return _this3.models.checkoutCart.action('patchCartData', {
                                        data: patchCartPayload
                                    });
                                }
                            } else {
                                return;
                            }
                        }
                    });
                } else {
                    return _angular.$q.when(); // not an inventory request proceed with existing flow
                }
            };

            var checkInventoryAndPay = function checkInventoryAndPay(checkoutSession) {
                return inventoryOperation().then(function (result) {
                    if (result && result.soldoutpage) {
                        return _uiRouter.$state.go('checkout.soldout', {
                            items: encodeURIComponent(result.items),
                            soldOutUrl: encodeURIComponent(result.soldOutUrl)
                        });
                    }
                    return makePayment(checkoutSession);
                });
            };

            var handlePaymentContingencies = function handlePaymentContingencies(code) {
                return function () {
                    inventoryOperation('failed');
                    return _uiRouter.$state.go('checkout.genericError', { code: code });
                };
            };

            var markCartCheckedout = function markCartCheckedout() {
                var shoppingCartModel = _index4.$ShoppingCartModel.instance(_angular.$rootScope.token);
                return shoppingCartModel.action('cartCheckedOut', {
                    data: {
                        payee_email: _this3.models.checkoutAppData.get('merchant.merchant_email')
                    },
                    success: function success(result) {
                        _logger.$logger.info('cart checked out successfully');
                    }
                });
            };

            var mapValidationErrors = function mapValidationErrors(err) {
                var fields = err && err.fields || [];
                fields.forEach(function (fieldError) {
                    if (fieldError && fieldError.property) {
                        fieldError.field = fieldError.property;
                    }
                });
                return {
                    fields: fields
                };
            };

            this.handleFIContingencies = function (data, fundingInstrument) {
                _this3.errorMessage = _util.$fiErrorUtil.addPageErrors(data, fundingInstrument);

                if (!_this3.errorMessage) {
                    _this3.errorMessage = {
                        msgs: [_index.$locale.content.get(fundingInstrument + '.errorGeneral')],
                        type: 'error'
                    };
                }

                errorHandlerHelper.scrollToElement();
            };

            var getContentIdentifier = function getContentIdentifier(tcpaIdentifier) {
                return _index.$locale.country + ':' + _index.$locale.lang + ':' + (0, _squid.$contentVersion)() + ':' + tcpaIdentifier;
            };

            /*
             * onBoardAccount and functions calling onBoardAccount
             */
            this.onBoardAccount = function () {

                // remove the page level errors
                _this3.errorMessage = '';

                // creating this variable shipping_address_validation for back-end whether to validate
                // the shipping address or not.
                // shipping address validation required only when shipping address is different than Billing Address
                // shipToBilling flag will be false when user tries to expand the shipping address in Billing Page
                _this3.onboard.shipping_address_validation = _this3.flags.allowEditShipping && !_this3.flags.shipToBilling;
                _this3.onboard.billing_address.country = _index.$locale.country;

                _this3.onboard.skipInitiateAuth = true;

                _this3.onboard.poma_flow = _this3.flags.poma_flow;
                _this3.onboard.content_identifier = getContentIdentifier(_this3.flags.tcpa_identifier);
                _this3.onboard.prox_flow = _this3.models.checkoutInputData.isEbayTxn();

                var action = void 0;
                // POMA should go in Singup rails, because poma usecase is passwordless member
                if (_this3.flags.poma_flow) {
                    action = 'signup';
                } else {
                    action = _this3.flags.mode === 'signup' ? 'signup' : 'guest';
                }

                return _this3.onboard.action(action, {

                    data: _this3.onboard.serialize(),

                    success: function success() {
                        return _angular.$q.when().then(function () {
                            if (_this3.flags.poma_flow) {
                                var locale_code = _index.$locale.lang + '_' + _index.$locale.country;
                                var locale_country = _index.$locale.country;
                                return _ul.$ul.optInToOneTouch(_this3.token, locale_country, locale_code).then(function (success) {
                                    _logger.$logger.info('UL_SUCCESSFULLY_DROPPED_RT_IN_COOKIE');
                                }, function (err) {
                                    // eslint-disable-line handle-callback-err
                                    _logger.$logger.info('UL_FAILED_DROPPED_RT_IN_COOKIE');
                                });
                            }
                        }).then(function () {
                            if (_this3.models.checkoutCart.isWalletTokenization()) {
                                (0, _squid.$dispatch)('hermes', {
                                    token: _this3.token,
                                    'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
                                    'country.x': _index.$locale.country
                                });
                            } else {
                                // fire conversion url for MORS offer in the sign up section, ad_id = 202002
                                if (_this3.MORSDisplayed && _this3.MORSDisplayed.placementId === '202002') {
                                    _index11.$fireMORSBeacon.fireBeacon(_this3.MORSDisplayed.clickURL);
                                }

                                if (_this3.onboard.card && _this3.onboard.card.type === 'CUP' && _this3.onboard.fundingId) {
                                    _this3.onboard.card.id = _this3.onboard.fundingId;
                                    _this3.launchUpopScreen = true;
                                } else {
                                    // Create Checkout-Session
                                    return createXO();
                                }
                            }
                        });
                    },

                    contingencies: {
                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                        CC_LINKED_TO_FULL_ACCOUNT: function CC_LINKED_TO_FULL_ACCOUNT() {
                            this.errorMessage = {
                                msgs: errorHandlerHelper.getPageError('creditcard.linkedCardToAddNewCard'),
                                type: 'error'
                            };
                        },
                        BANK_LINKED_TO_FULL_ACCOUNT: function BANK_LINKED_TO_FULL_ACCOUNT() {
                            this.errorMessage = {
                                msgs: errorHandlerHelper.getPageError('bank.linkedBankError'),
                                type: 'error'
                            };
                        },
                        EXISTING_ACCOUNT_RESTRICTED: function EXISTING_ACCOUNT_RESTRICTED() {
                            this.errorMessage = {
                                msgs: errorHandlerHelper.getPageError('creditcard.riskDisallowed'),
                                type: 'error'
                            };
                        },
                        TOO_MANY_REQUESTS: function TOO_MANY_REQUESTS() {
                            this.errorMessage = {
                                msgs: errorHandlerHelper.getPageError('genericError.genericError'),
                                type: 'error'
                            };
                        },
                        VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, data) {
                            _this3.errorMessage = _util.$fiErrorUtil.addPageErrors(data, _this3.locale, 'bank');
                            _util.$fiErrorUtil.addFieldErrors(data, _this3.sectionElement);
                        },
                        ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(result, err) {
                            _this3.handleFIContingencies(err, 'creditcard');
                        },
                        ADD_BANK_CONTINGENCY: function ADD_BANK_CONTINGENCY(result, err) {
                            _this3.handleFIContingencies(err, 'bank');
                        },
                        RISK_DISALLOWED: function RISK_DISALLOWED() {
                            this.errorMessage = {
                                msgs: errorHandlerHelper.getPageError('creditcard.riskDisallowed'),
                                type: 'error'
                            };
                        },
                        VALIDATION_ERROR: function VALIDATION_ERROR(message, errorData) {
                            var errorMsgs = errorHandlerHelper.errorHandler(message, errorData, _this3.actions.positionToErrorField);

                            if (errorMsgs && errorMsgs.length > 0) {
                                _this3.errorMessage = {
                                    msgs: errorMsgs,
                                    type: 'error'
                                };
                            }
                        }
                    },

                    validation: function validation(res) {
                        // should catch any primary check failures like schema validations etc
                        _util.$fiErrorUtil.addFieldErrors(mapValidationErrors(res), _this3.sectionElement);
                    }
                });
            };

            var addShippingAddress = function addShippingAddress() {

                return _squid.$promise.call(function () {
                    // Add shipping address if edit shipping is allowed. this.flags.allowEditShipping flag used
                    // to show "ship to Billing" checkbox
                    if (_this3.flags.allowEditShipping) {
                        var shippingAddress = _this3.onboard.shipping_address;
                        shippingAddress.recipient_name = shippingAddress.first_name + ' ' + shippingAddress.last_name;
                        return shippingAddress.save({
                            data: _this3.onboard.shipping_address.serialize(),
                            validation: function validation(message, errorData) {
                                var errorMsgs = errorHandlerHelper.errorHandler(message, errorData, _this3.actions.positionToErrorField);

                                if (errorMsgs && errorMsgs.length > 0) {
                                    _this3.errorMessage = {
                                        msgs: errorMsgs,
                                        type: 'error'
                                    };
                                }
                            }
                        });
                    }
                });
            };

            var createXO = function createXO() {
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this3.token);

                return checkoutSession.action('create', {
                    data: {
                        fraudnet_id: _this3.models.checkoutCart.supplementary && _this3.models.checkoutCart.supplementary.risk_correlation_id,
                        baToken: _this3.models.checkoutCart.billing && _this3.models.checkoutCart.billing.ba_token
                    },

                    success: function success() {

                        return _angular.$q.when().then(function () {

                            return addShippingAddress();
                        }).then(function () {
                            /*
                             * If checkoutSession has DCC enabled, then we do updateConversion call and upate to VENDOR if:
                             * 1. Pre-Plan (Non-Visa DCC) if VENDOR was selected in interstitial from link on Billing page,
                             *    otherwise PAYPAL is default selection.
                             * 2. Post-Plan (Visa DCC) default selection to VENDOR for signup case, since we don't show DCC
                             *    interstitial for signup experience.
                             */
                            if (checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable') && (_this3.flags.mode === 'signup' && _this3.onboard.card.type === 'VISA' || _this3.onboard.card.ppconversion === 'VENDOR')) {
                                return _index2.$FundingOptionsModel.instance(_this3.token).action('updateConversion', {
                                    data: {
                                        conversionType: 'VENDOR',
                                        planId: checkoutSession.plan.id
                                    }
                                })['catch']();
                            }
                        }).then(function () {
                            if (checkoutSession.get('cvvData')) {
                                checkoutSession.set('cvvData.security_code', _this3.onboard.get('card.security_code'));
                            }

                            return _fiApis.$fiApis.patchCvv(checkoutSession).then(postCheckoutSessionOperations, function (err) {
                                _logger.$logger.error('patchCvv error', err);
                            });
                        });
                    },

                    contingencies: {
                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                        NEED_SHIPPING_ADDRESS: function NEED_SHIPPING_ADDRESS() {
                            return _this3.onboard.shipping_address.save({
                                data: _this3.onboard.shipping_address.serialize(),
                                validation: function validation(message, errorData) {
                                    var errorMsgs = errorHandlerHelper.errorHandler(message, errorData, _this3.actions.positionToErrorField);

                                    if (errorMsgs && errorMsgs.length > 0) {
                                        _this3.errorMessage = {
                                            msgs: errorMsgs,
                                            type: 'error'
                                        };
                                    }
                                }
                            });
                        },
                        NEED_CREDIT_CARD_OR_BANK_ACCOUNT: function NEED_CREDIT_CARD_OR_BANK_ACCOUNT() {
                            return handleCardContingency();
                        },
                        NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
                            return handleCardContingency();
                        },
                        SENDING_LIMIT_EXCEEDED: function SENDING_LIMIT_EXCEEDED() {
                            /* 1. Introducing config attribute sendingLimitNoFallback for certain countries right now
                             only Japan, to go to generic error page in case of sending limit exceeded. this config
                             will be removed once all countries have proper content available.
                             2. Currently only guest mode will go to generic error page as signup mode need to handle
                             SENDING_LIMIT_EXCEEDED AND TRANSACTION_LIMIT_EXCEEDED separately but we are not getting expected
                             contingency from Symphony yet. Will remove scope.flags.mode === 'guest' condition once we are getting
                             expected contingency back.
                             */
                            if ((0, _index.$feature)('sendingLimitNoFallback') && _this3.flags.mode === 'guest') {
                                _uiRouter.$state.go('checkout.genericError', { code: 'TRANSACTION_LIMIT_EXCEEDED' });
                            } else {
                                throw new _index.$FallbackError({
                                    reason: 'sending_limit_exceeded',
                                    product: 'ux'
                                });
                            }
                        },
                        NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD() {
                            // Contingency purpose - Show OTP confirmation popup
                            // As we have already presented user with OTP popup with
                            // init call after add card (flag - launchUpopScreen),
                            // we need to redirect user to hermes at this point
                            (0, _squid.$dispatch)('hermes', {
                                token: _this3.token,
                                'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
                                'country.x': _index.$locale.country
                            });
                        }

                    }
                });
            };

            this.onUpopSuccess = function () {
                _this3.launchUpopScreen = false;
                return createXO();
            };

            this.onUpopCancel = function (errorData) {
                _this3.launchUpopScreen = false;

                if (_this3.flags.mode === 'signup') {
                    // If signup user closes the OTP popup window(or some error in flow)
                    // then call create checkout session, and this will intern redirect
                    // to hermes with NEED_AUTHENTICATED_CARD contingency
                    return createXO();
                } else if (errorData) {

                    // If guest user closes the OTP popup window(or some error in flow)
                    // then show a page level error to the user
                    // There is no redirect to hermes in guest case
                    if (errorData && errorData.errorCodes && errorData.errorCodes[0] === 'RESTRICTED_CARD') {
                        // Custom error messaging for RESTRICTED_CARD errorCode.
                        // RESTRICTED_CARD_GUEST content key is applicable for both Guest & Signup flows.
                        errorData.errorCodes[0] = 'RESTRICTED_CARD_GUEST';
                    }

                    // prop for last 4 digits of card in error message
                    var prop = {
                        number: _this3.onboard.card.last4()
                    };
                    _this3.errorMessage = _util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error');
                }
            };

            this.uponNormalization = function (normalizedAddress, isBack) {
                _this3.showAddressNormalizationLightbox = false;

                var newBilling = _index8.$BillingAddressModel.create(_this3.token, normalizedAddress, {
                    id: '0'
                });

                _this3.onboard.billing_address = newBilling;

                if (_this3.flags.shipToBilling) {
                    _this3.onboard.shipping_address.first_name = _this3.onboard.user.first_name;
                    _this3.onboard.shipping_address.last_name = _this3.onboard.user.last_name;
                }

                return _this3.onBoardAccount();
            };

            this.toggleAddressFieldsValidation = function (toggle) {

                if (_this3.flags.shipToBilling) {
                    _this3.billingAddressValidated = toggle;
                } else {
                    _this3.shippingAddressValidated = toggle;
                }
            };

            /*
             * Before submit the transaction, need to update shipping address if this.flags.shipToBilling is set
             * Also update city/state/zip value if the city/state/zip element is not present for the selected country
             * TODO: should enhance this function to compare the address entry from metadata based on country,
             *       the tricky part is need to consider to load metadata separately for billing and shipping
             *       if their country is different
             */
            this.updateAddressOnSubmit = function () {
                var billingState = $('#billingAddress #state')[0] || $('#billingAddress #billingState')[0];
                var shippingState = $('#shippingAddress #state')[0] || $('#shippingAddress #shippingState')[0];
                var billingCity = $('#billingAddress #city')[0] || $('#billingAddress #billingCity')[0];
                var shippingCity = $('#shippingAddress #city')[0] || $('#shippingAddress #shippingCity')[0];
                var billingZip = $('#billingAddress #postalCode')[0] || $('#billingAddress #billingPostalCode')[0];
                var shippingZip = $('#shippingAddress #postalCode')[0] || $('#shippingAddress #shippingPostalCode')[0];

                // Before submit the onboarding request, we need to make sure billing address country code is user selected country
                _this3.onboard.billing_address.country = _index.$locale.country;

                if (!billingCity) {
                    delete _this3.onboard.billing_address.city;
                }

                if (!billingState) {
                    delete _this3.onboard.billing_address.state;
                }

                if (!billingZip) {
                    delete _this3.onboard.billing_address.postal_code;
                }

                if (_this3.flags.shipToBilling) {
                    _this3.onboard.shipping_address = _index2.$ShippingAddressModel.create(_this3.token, _this3.onboard.billing_address, {
                        first_name: _this3.onboard.user.first_name,
                        last_name: _this3.onboard.user.last_name
                    });
                } else {
                    _this3.onboard.shipping_address.first_name = _this3.onboard.shipping_address.first_name || _this3.onboard.user.first_name;
                    _this3.onboard.shipping_address.last_name = _this3.onboard.shipping_address.last_name || _this3.onboard.user.last_name;

                    if (!shippingState) {
                        delete _this3.onboard.shipping_address.state;
                    }

                    if (!shippingCity) {
                        delete _this3.onboard.shipping_address.city;
                    }

                    if (!shippingZip) {
                        delete _this3.onboard.shipping_address.postal_code;
                    }

                    // Shipping / Billing Address Difference Detection
                    var addrDiffDetected = compareShippingBillingAddrs(_this3.onboard.shipping_address, _this3.onboard.billing_address);
                    if (addrDiffDetected) {
                        var addrDiff = {
                            is_ship_addr_diff: 1,
                            page: 'main:ec:hermes::fullpage-billing:guest:hermes:'
                        };
                        _angular.$rootScope.$broadcast('addrDiff', addrDiff);
                    }
                }
            };

            // Case insensitively compare all string properties of shipping and billing address to detect difference.
            // This method is designed to work with any country with any set of address input fields.
            var compareShippingBillingAddrs = function compareShippingBillingAddrs(shipping_addr, billing_addr) {
                var diffDetected = false;

                for (var prop in shipping_addr) {
                    if (shipping_addr.hasOwnProperty(prop) && billing_addr.hasOwnProperty(prop)) {
                        if (angular.isString(shipping_addr[prop]) && angular.isString(billing_addr[prop])) {
                            if (shipping_addr[prop].toUpperCase() !== billing_addr[prop].toUpperCase()) {
                                // Special handling for postal code
                                if (prop === 'postal_code') {
                                    diffDetected = checkZip(shipping_addr[prop], billing_addr[prop]);
                                } else {
                                    diffDetected = true;
                                }
                            }
                        }
                    }
                }

                // Special case zip check to ignore differences in zipcode format
                function checkZip(zip1, zip2) {
                    var longerZip = zip1.length > zip2.length ? zip1 : zip2;
                    var shorterZip = longerZip === zip1 ? zip2 : zip1;
                    if (longerZip.indexOf(shorterZip) > -1) {
                        return false;
                    }
                    return true;
                }

                return diffDetected;
            };

            var enableSnT = function enableSnT() {
                if (_this3.flags.wps_SnT_flow && !_this3.flags.allowSnTCall) {
                    // SnT should be allowed if there is an contingency during OnBoard.
                    _this3.flags.allowSnTCall = true;
                }
            };

            var handleAllLoadedForSnT = _angular.$rootScope.$on('allLoaded', enableSnT);

            this.$on('destroy', handleAllLoadedForSnT);

            var routeToHermesOn3DSDeclineForSignUp = function routeToHermesOn3DSDeclineForSignUp() {
                // dispatch to hermesnodeweb up on 3DS authenticate decline.
                _logger.$logger.info('xoon_to_hermes_redirect_on_signup_3DS_Authentication_decline');
                (0, _squid.$dispatch)('hermes', {
                    redirectToHermesOn3DSDecline: 'xoon',
                    token: _this3.token,
                    'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
                    'country.x': _index.$locale.country
                });
            };

            /**
             * call patchXO API to clear the 3DS contingency and then call authorize API.
             */
            var clear3DSContingency = function clear3DSContingency() {
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this3.token);
                return checkoutSession.action('clear3DSContingency', {
                    data: {
                        ccId: checkoutSession.resolve_3ds.ccId
                    },
                    success: function success() {
                        // don't call authorize if the contingency is not cleared
                        if (!checkoutSession.resolve_3ds) {
                            return authorize();
                        } else {
                            _this3.errorMessage = {
                                msgs: errorHandlerHelper.get3dsPageWarning(checkoutSession.resolve_3ds, 'threeDS.guestDeclineAfter3DSAccept'),
                                type: 'warning'
                            };
                        }
                    },
                    contingencies: {
                        // contingency may be "no cc" or any thing from clear3DSContingency(patch on xosession)
                        // for "no cc" symphony throws NEED_CREDIT_CARD or NEED_CREDIT_CARD_OR_BANK_ACCOUNT
                        DEFAULT: function DEFAULT(name, contingency) {
                            _logger.$logger.info('clear3DSContingency_contingency', {
                                'int_error_description': contingency && contingency.message,
                                'contingency_name': name
                            });

                            if (_this3.flags.mode === 'signup') {
                                // route to member review page upon patch xo throws contingency for signup
                                routeToHermesOn3DSDeclineForSignUp();
                            } else {
                                _this3.errorMessage = {
                                    msgs: errorHandlerHelper.get3dsPageWarning(checkoutSession.resolve_3ds, 'threeDS.guestDeclineAfter3DSAccept'),
                                    type: 'warning'
                                };
                            }
                        }
                    }
                });
            };

            this.onComplete3DSHandler = function (status) {
                _this3.launch3DSResolver = false;
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this3.token);
                if (status === 'decline') {
                    // Flow should route to member review page for sign up case
                    // up on receiving "decline" response from 3DS authenticate call
                    if (_this3.flags.mode === 'signup') {
                        routeToHermesOn3DSDeclineForSignUp();
                    } else {
                        // guest case
                        _this3.errorMessage = {
                            msgs: errorHandlerHelper.get3dsPageWarning(checkoutSession.resolve_3ds, 'threeDS.guestDecline'),
                            type: 'warning'
                        };
                    }
                } else if (status === 'close') {
                    // Closing the 3DS page should route the flow to member review for sign up case
                    // because the member account is created already.
                    // Guest remains in the Billing page, no re-direction.
                    if (_this3.flags.mode === 'signup') {
                        routeToHermesOn3DSDeclineForSignUp();
                    }
                } else if (status === 'success') {
                    // Up on Successful authenticate, perform Patch on XO session and authorise.
                    clear3DSContingency();
                }
            };
        } // populate

    },

    actions: {
        toggleFIMode: function toggleFIMode(event, mode) {
            event.preventDefault();
            this.onboard.fiMode = mode;
        },
        goBack: function goBack(event) {
            (0, _squid.$dispatch)('hermes', {
                redirectToHermes: true,
                token: this.token
            });
        },


        // Enable user to edit shipping address
        editShippingAddress: function editShippingAddress() {
            this.flags.showSingleAddress = false;
            this.flags.allowEditShipping = true;
            this.flags.disallowShipToBilling = true;
            this.flags.shipToBilling = false;
            this.flags.hideShippingAddress = false;
            _angular.$rootScope.$emit('change_in_shipping_address');
        },
        logWebviewBackButtonClick: function logWebviewBackButtonClick() {
            if (this.flags.backButtonWebview) {
                _logger.$logger.info('BACK_BUTTON_FOR_WEBVIEW_CLICKED');
            }
        },
        onSubmit: function onSubmit() {
            if (this.isInstantUpdateFlow) {
                var currentShippingAddress = this.flags.shipToBilling ? this.onboard.billing_address : this.onboard.shipping_address;
                if ((0, _util2.hasAddressChanged)(this.trackSntReq.address, currentShippingAddress)) {
                    _logger.$logger.info('address_changed_trigger_snt');
                    _angular.$rootScope.$emit('submission_triggered');
                    return;
                }
                if (!this.flags.instantUpdateShippingRegionSupported) {
                    _logger.$logger.info(this.flags.mode + '_submit_not_allowed_instant_update_shipping_region_unsupported');
                    return;
                }
            }

            if (this.flags.wps_SnT_flow || this.isInstantUpdateFlow) {
                /**
                 * During submit , if SnT is triggered , do not allow Pay .
                 */
                if (!this.flags.allowPayWithSnT) {
                    _logger.$logger.info(this.flags.mode + '_submit_not_allowed_without_SnT_completion');
                    return;
                }
                // Any SnT Call triggered when xoon updates the address for checkout should not be allowed.
                this.flags.allowSnTCall = false;
            }

            _logger.$logger.info(this.flags.mode + '_submit', {
                type: this.onboard.fiMode === 'bank' ? 'BANK' : this.onboard.card.type,
                country: _index.$locale.country,
                lang: _index.$locale.lang
            }).flush();

            if (this.flags.nationalIdFlag) {
                this.onboard.nationalIdModel = _directive.$NationalIdModel.instance(_angular.$rootScope.token);
            }

            if (this.flags.mode !== 'signup') {
                delete this.onboard.user.password;
            }

            this.updateAddressOnSubmit();

            if (this.onboard.card.type === 'CUP' && this.onboard.card.isCupSecureCard) {
                this.flags.allowSnTCall = true;
                // CUP Secure card is not supported in our flow
                return this.handleFIContingencies({}, 'creditcard');
            }

            if ((0, _index.$feature)('addressNormalization')) {
                this.showAddressNormalizationLightbox = true;
            } else {
                return this.onBoardAccount();
            }
        },
        positionToErrorField: function positionToErrorField() {
            var _this4 = this;

            var errorFields = $('.backendError:visible, input:visible.ng-invalid, select:visible.ng-invalid');
            var firstErrorField = errorFields && errorFields.length && errorFields[0];

            // Sets the styling for validation on singlePagePaymentForm
            this.validated = true;

            // AB testing - fixes the revious bug of marking the email and password
            // as required when the user selects the 'yes' button for the first time
            this.flags.ignoreValidationTheFirstTime = false;

            if (firstErrorField) {
                firstErrorField.focus();
            } else {
                errorHandlerHelper.scrollToElement();
            }

            $('.backendError:visible').on('blur', function (event) {
                $(_this4).removeClass('backendError');
            });

            if ($('#installments').length) {
                $('#paymentMethod').addClass('ng-invalid');
            } else {
                $('#paymentMethod').removeClass('ng-invalid');
            }

            return true;
        }
    }
});


_angular.$q;

_angular.$rootScope;

_ul.$ul;

_squid.$contentVersion;

_squid.$experiment;

_squid.$promise;

_squid.$renderContent;

_squid.$pxp;

_squid.$dispatch;

_squid.$meta;

_index.$Component;

_index.$FallbackError;

_index.$config;

_index.$feature;

_index.$locale;

_index.$util;

_index2.$CheckoutSessionModel;

_index2.$FundingOptionsModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutCartModel;

_index2.$ShippingAddressModel;

_index2.$InstallmentOptionsModel;

_index3.$CheckoutInputDataModel;

_index4.$ShoppingCartModel;

_index5.$ShippingRuleSummaryModel;

_index6.$InventoryModel;

_index7.$OnboardModel;

_index7.$OnboardUserModel;

_index7.$OnboardPhoneModel;

_index8.$BankModel;

_index8.$CardModel;

_index8.$BillingAddressModel;

_fiApis.$fiApis;

_index9.$AuthModel;

_logger.$logger;

_uiRouter.$state;

_index10.$DeviceInfo;

_index11.$fireMORSBeacon;

_directive.$NationalIdModel;

_util.$fiErrorUtil;

_sticky.setStickyInstrument;

_util2.hasAddressChanged;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/directive.js
// module id = ./components/xo-guest-components/src/guest/directive.js
// module chunks = 1